'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Sortable = require('sortablejs/Sortable');

var _Sortable2 = _interopRequireDefault(_Sortable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageController = function () {
  function PageController(ProductPagesDataProvider, $state) {
    "ngInject";

    (0, _classCallCheck3.default)(this, PageController);
    this.ProductPagesDataProvider = ProductPagesDataProvider;
    this.$state = $state;
    this.currentPage = 1;
    this.pageLimit = '100';
    this.maxSize = 5;
    this.pageLimitOptions = { 10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All' };
    var parentId = $state.params.parentId;
    if (parentId == 'all') {
      parentId = 0;
    }
    this.parentId = parentId;
    this.field = 'parent_id,order_by';
    this.order_type = 'asc';
    this.col = 0;
    this.colTopDown = 0;
    if (parentId != 0) {
      this.pageLimit = '9999';
      var el = document.getElementById('items');
      var vm = this;
      vm.sortingLog = [];
      var sortable = _Sortable2.default.create(el, {
        onStart: function onStart(evt) {
          evt.oldIndex;
          console.log('start');
        },
        onEnd: function onEnd(evt) {
          var oldData = angular.copy(vm.categories);
          var i = 0;
          if (evt.oldIndex < evt.newIndex) {
            for (i = evt.oldIndex; i <= evt.newIndex; i++) {
              if (i == evt.newIndex) {
                vm.categories[i] = oldData[evt.oldIndex];
              } else {
                vm.categories[i] = oldData[i + 1];
              }
            }
          }
          if (evt.oldIndex > evt.newIndex) {
            for (i = evt.oldIndex; i >= evt.newIndex; i--) {
              if (i == evt.newIndex) {
                vm.categories[i] = oldData[evt.oldIndex];
              } else {
                vm.categories[i] = oldData[i - 1];
              }
            }
          }
          vm.categories.map(function (i) {
            vm.sortingLog.push(i.id);
          });
          ProductPagesDataProvider.updateCategoryOrder(vm.sortingLog).then(function (result) {
            vm.getRecords();
          });
          vm.sortingLog = [];
        }
      });
    }
    this.getRecords();
  }

  (0, _createClass3.default)(PageController, [{
    key: 'getSortRecors',
    value: function getSortRecors(field, order_type, col, colTopDown) {
      this.field = field;
      this.order_type = order_type;
      this.col = col;
      this.colTopDown = colTopDown;
      this.getRecords();
    }
  }, {
    key: 'getRecords',
    value: function getRecords() {
      var vm = this;
      var data = [];
      data.currentPage = vm.currentPage;
      data.pageLimit = vm.pageLimit;
      data.parentId = vm.parentId;
      data.field = vm.field;
      data.order_type = vm.order_type;
      vm.ProductPagesDataProvider.getSubCategory(data).then(function (result) {
        vm.categories = result.data;
        vm.categoriesTotal = result.total;
      });
    }
  }, {
    key: 'removeCategory',
    value: function removeCategory(id) {
      if (confirm("Are you sure to delete!") !== true) {
        return false;
      }
      var vm = this;
      vm.ProductPagesDataProvider.removeCategory(id).then(function (res) {
        vm.getRecords();
      });
    }
  }, {
    key: 'changeStatus',
    value: function changeStatus(status, id) {
      var vm = this;
      var data = { 'status': status, 'id': id };
      vm.ProductPagesDataProvider.updateCategory(data).then(function (resp) {
        vm.getRecords();
      });
    }
  }]);
  return PageController;
}();

// WEBPACK FOOTER //


exports.default = PageController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/product-page/components/subcategory_listing/controller.js
 **/